import { render } from "./TakEawaypizzabox.vue?vue&type=template&id=7f303a4f"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEawaypizzabox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f303a4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f303a4f', __exports__)) {
    api.reload('7f303a4f', __exports__)
  }
  
  module.hot.accept("./TakEawaypizzabox.vue?vue&type=template&id=7f303a4f", () => {
    api.rerender('7f303a4f', render)
  })

}


export default __exports__